import { call, select } from "redux-saga/effects";

import { doesOrganizationSupportMileageTracking } from "@app/store/iam";
import DistanceTravelledCardConfiguration from "@app/types/dashboard/cards/distanceTravelled/DistanceTravelledCardConfiguration";
import DistanceTravelledCardData from "@app/types/dashboard/cards/distanceTravelled/DistanceTravelledCardData";
import Scope from "@app/types/dashboard/Scope";

import { granularityByDateRange } from "../common";

import fetchDistanceTravelledFromDistances from "./fetchFromDistances";
import fetchDistanceTravelledFromTrips from "./fetchFromTrips";
import resolveScopedUserIds from "./resolveScopedUserIds";

export function* fetchDistanceTravelledCardDataHelper(params: {
  callback: (data: DistanceTravelledCardData) => void;
  configuration: DistanceTravelledCardConfiguration;
  scope?: Scope;
}): Generator<unknown, void, never> {
  const { callback, configuration, scope } = params;
  const granularity = granularityByDateRange[configuration.dateRange.range];

  const { isOwnUserScope, userIds } = yield* resolveScopedUserIds(scope);

  // Trips only exist for orgs on Mileage Tracker. Everyone else reads the distances table,
  // which falls back to GPS-derived passive distance, rather than rendering a permanent zero.
  const supportsMileageTracking: boolean = yield select(doesOrganizationSupportMileageTracking);

  const result: DistanceTravelledCardData = supportsMileageTracking
    ? yield call(fetchDistanceTravelledFromTrips, {
        configuration,
        granularity,
        isOwnUserScope,
        userIds,
      })
    : yield call(fetchDistanceTravelledFromDistances, { configuration, granularity, userIds });

  yield call(callback, result);
}

export default fetchDistanceTravelledCardDataHelper;
